import { render, staticRenderFns } from "./DetalheOferta.vue?vue&type=template&id=33909d31&scoped=true&"
import script from "./DetalheOferta.vue?vue&type=script&lang=js&"
export * from "./DetalheOferta.vue?vue&type=script&lang=js&"
import style0 from "./DetalheOferta.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetalheOferta.vue?vue&type=style&index=1&id=33909d31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33909d31",
  null
  
)

export default component.exports